/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NextOfKinInput { 
    id?: number;
    nextOfKinId?: number;
    nextOfKinFullName?: string | null;
    nextOfKinGender?: string | null;
    nextOfKinDOB?: string | null;
    relationshipId?: number | null;
    nextOfKinPhoneNumber?: string | null;
    nextOfKinEmailId?: string | null;
    isDeleted?: boolean;
}

